// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8183510f","970":"ce0d5fe7"}[chunkId] + ".chunk.js";
};